export const SIDEBAR_BTNS = [
    { name: "applications", to: "/settings", permissionCode: { parent: "AS", child: ["HL", "PE", "GR", "WS"] } },
    { name: "processes", to: "/processes", permissionCode: "DI" },
    { name: "smartContractList", to: "/smartContractList", permissionCode: "SC" },
    { name: "userInterfaces", to: "/userInterfaces", permissionCode: "IB" },
    { name: "documents", to: "/documentTemplates", permissionCode: "DB" },
    { name: "apis", to: "/integrations", permissionCode: "AP" },
    { name: "dataModel", to: "/dataModel", permissionCode: "DM" },
    { name: "catalogs", to: "/catalogs", permissionCode: ["CS", "CD"] },
    { name: "perspectiveBuilder", to: "/customDataViews", permissionCode: ["PB"] },
    { name: "search", to: "/dataViews", permissionCode: "DP" },
    { name: "reports", to: "/analytics/processLiveView", permissionCode: { parent: "RP", child: ["TI", "ST"] } }
];

export const CHECK_PERMISSIONS_INTERFACES = ["dashboard", "appsMainPage", "administration", "processInspector"];

export const ONE_AT_A_TIME_PERMISSIONS_CHECK = [
    { name: "highlights", code: "HL" },
    { name: "appSpecificGroups", code: "GR" },
    { name: "permissions", code: "PE" },
    { name: "dataModel", code: "DM" },
    { name: "catalogs", code: ["CS", "CD"] }
];

export const APP_SUBROUTES_LIST = [
    "processes",
    "ProcessList",
    "StatusReport",
    "diagrams",
    "process",
    "userInterfaces",
    "documents",
    "apis",
    "consumed",
    "internalApis",
    "expose",
    "dataModel",
    "catalogs",
    "perspectiveBuilder",
    "search",
    "reports",
    "statistics",
    "smartContractContainer",
    "smartContract",
    "smartContractList",
    "newSmartContract",
    "useTemplate",
    "startFromScratch",
    "smartContractDesigner",
    "highlights",
    "appSpecificGroups",
    "appSchedule",
    "permissions"
];
